import $ from 'jquery'
import _ from 'lodash'
import template from './datasets-create.hbs'
import FormView from 'scoreboard/components/form-view'
import i18n from 'scoreboard/components/i18n'
import DisplayHeader from 'scoreboard/components/display-header'
import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import EditForm from 'scoreboard/components/edit/edit-form'
import * as DataSourceTypes from 'scoreboard/components/import-data-source/import-data-source-types'
import Backbone from 'backbone'
import conductor from 'scoreboard/components/conductor'
import formHelper from 'scoreboard/components/form-helper'
import guard from 'scoreboard/components/unsaved/guard'
import appDisplay from 'scoreboard/components/app-display'
import DatasetsWizard from './datasets-wizard'
import TilesWithIconOptions from 'scoreboard/components/tiles-with-icon-options'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import { isV6 } from 'scoreboard/components/version'

const CreateView = Backbone.View.extend({
	/** @type {Dataset} */
	model: null,

	className: 'datasets-edit table-hack display-layout',

	events: {
		'click .cancel': 'onClickCancel',
	},

	/**
	 * A form that allows a user to create a new dataset
	 *
	 * @constructs
	 *
	 * @param {Object} [options]
	 *
	 * @param {Dataset} options.model the dataset to be built, with the
	 * relativeId specified
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			allowCleanSubmission: true,
			toggleCancel: true,
			submit: this.submit.bind(this)
		})
		this.formView.on('change', () => this.onChangeLabel())

		this.menuOptions = DataSourceTypes.menuOptions(this.model)
	},

	render: function() {
		this.renderHeader()
		this.$el.append(template())

		// by default, the "upload" data source type is chosen
		this.dataSourceType = 'upload'
		this.renderEditForm()

		this.formView.start({
			isNew: true,
			primaryButtonEl: this.$('.save')
		})

		let labelInput = this.$('[name=label]')

		labelInput.select()

		if (isV6()) {
			this.markedField = new MarkedField({
				el: labelInput,
				validator: requiredValidator
			}).render()
		}

		// by default, the "upload" data source type is chosen
		this.dataSourceType = 'upload'
		// highlight the default datasource type as selected
		this.$(`[data-type="${this.dataSourceType}"`).addClass('is-selected')
		// update the submit button label
		this.updatePrimaryButtonLabel()
		return this
	},

	renderHeader: function () {
		let tabContext = {
			id: this.model.get('relativeId'),
			section: this.model.section,
			overviewTabCode: 'common.explore'
		}

		this.header = new DisplayHeader({
			heading: i18n.get('common.create2', 'datasets.dataset'),
			model: this.model,
			subsection: 'edit',
			// TODO: Remove when V5 is no longer supported
			// Only remove the isV6() check.
			tabs: this.model.isNew() && isV6() ? '' : viewEditTabs(tabContext)
		})

		this.$el.empty().append(this.header.el)
		this.header.render()
	},

	renderEditForm: function () {
		this.dataSourceOptions = new TilesWithIconOptions({
			labelKey: 'datasets.dataSource',
			defaultValue: this.dataSourceType,
			tooltipFn: (target) => {
				DataSourceTypes.displayTooltipIfNotImplemented(target,
					this.model, this.menuOptions)
			},
			sections: this.menuOptions
		}).render()
		this.dataSourceOptions.on('option-selected', (selectedType) => {
			this.dataSourceType = selectedType
			this.updatePrimaryButtonLabel()
		})
		// EditForm, with advanced layout options of data source types
		this.editForm = new EditForm({
			model: this.model,
			section: 'datasets',
			advancedLayoutOptions: this.dataSourceOptions.$el,
			// TODO: Remove when V5 is no longer supported
			// Should just be true
			hideFormContent: isV6() ? true : false
		})
		this.editForm.on('save', () => this.formView.submit())
		this.editForm.on('cancel', () => this.onClickCancel())

		this.$('.scroll-container').append(this.editForm.el)
		this.editForm.render()
		// set the default dataset name
		this.editForm.labelField.val(i18n.get('datasets.new'))
	},

	onChangeLabel: function() {
		// potentially update the "New Dataset" placeholder in the tree
		this.model.set('label', this.editForm.val())
		this.trigger('change', this.model.toJSON())
	},

	updatePrimaryButtonLabel: function() {
		// for most data source types, the button label is "Next"
		let label = i18n.get('common.next')
		// if "None" is selected, the button label is "Create"
		if (this.dataSourceType === 'none') {
			label = i18n.get('common.create')
		}
		this.$('.button-primary').text(label)
	},

	saveState: function() {
		const data = formHelper.readFromDom(this.el)
		this.model.set(data)
		// set "tracked" to the default "Records", this may be edited after the
		// dataset has been created
		this.model.set('tracked', i18n.get('datasets.records'))
		let dataSourceMetadata = this.model.getDataSourceMetadata()
		if (this.dataSourceType === 'none') {
			_.unset(dataSourceMetadata, 'source')
		} else {
			let selectedDataSourceType = DataSourceTypes.byType(
				this.dataSourceType, this.model, this.menuOptions)
			this.selectedDataSourceType = selectedDataSourceType
			let { groupType, type } = selectedDataSourceType || {}
			if (groupType === 'spreadsheet') {
				// for spreadsheet sources, the 'source' will be the type
				dataSourceMetadata.source = type
			} else {
				// for db sources, the 'source' will be the groupType (ex 'database')
				dataSourceMetadata.source = groupType
			}
		}
	},

	submit: function() {
		this.saveState()

		// first validate the dataset's label
		return $.ajax({
			method: 'post',
			url: this.model.getValidateDataSourceUrl(),
			data: JSON.stringify(this.model),
			success: dataset => {
				this.model.set(dataset)
				const metadata = this.model.get('dataSourceMetadata')
				// if 'None' was selected, save the dataset as-is
				if (_.isNil(metadata.source)) {
					this.save()
				} else {
					//for all other data source types, open the datasets wizard
					this.openDatasetsWizard()
				}
			},
			error: xhr => {
				const messageCode = _.get(xhr, 'responseJSON.messageCode')
				if (messageCode && messageCode === 'datasets.error.namesTooSimilar') {
					const args = _.get(xhr, 'responseJSON.arguments') || []
					// make sure the name field is in view before adding tooltip
					this.$('.scroll-container').scrollTop(0)
					this.editForm.labelField.error(i18n.highlight(messageCode, args[0]))
					this.formView.resetForm()
					return
				}
				this.formView.error(xhr)
			}
		})
	},

	save: function() {
		return this.model.save(null, {
			success: (model) => {
				this.trigger('done', model)
				// display the overview for the saved dataset
				conductor.navigate('datasets/' + model.id, { trigger: true })
			},
			error: xhr => {
				this.formView.error(xhr)
			}
		})
	},

	openDatasetsWizard: function() {
		guard.conditionallyRun(() => {
			appDisplay.dialog($.get('api/admin/import-connections'), connections => {
				let relativeId = this.model.get('relativeId')
				let wizard = new DatasetsWizard({
					model: this.model,
					relativeId,
					connections,
					accept: 'spreadsheetOrZip',
					useDatasetInstructions: true,
					formatValues: false,
					dataSourceTypeChosen: true,
					dataSourceTypeObj: this.selectedDataSourceType
				})
				wizard.on('cancel', () => {
					this.model.deleteFile()
					// #50726 #50724 clear out the dataSourceMetaData after
					// cancelling the dataset wizard
					this.model = this.model.set('dataSourceMetadata', {})
					// if the wizard is cancelled, leave the 'new dataset' form
					// open and cancellable
					this.formView.start({
						isNew: true,
						primaryButtonEl: this.$('.save')
					})
				})
				wizard.on('done', () => {
					// display the overview for the saved dataset
					conductor.navigate('datasets/' + this.model.id, { trigger: true })
				})
				return wizard._view()
			})
		})
	},

	onClickCancel: function() {
		if (conductor.id()) {
			conductor.overview()
		} else {
			let url = `organizations/${this.model.get('organizationId')}/datasets`
			conductor.navigate(url, { trigger: true })
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.editForm, this.formView, this.header, this.tooltip],
			'remove')
	}

})

export default CreateView

CreateView.__filename__ = 'datasets/edit/datasets-create.js'
